import AllnewsScreen from './containers/allnewsScreen'

export {default as AllnewsScreenLayout} from './components/allnewsScreenLayout'

export default AllnewsScreen
